import { FC, ReactNode, useCallback } from "react"
import classNames from "classnames"
import { Link as RouterLink } from "react-router"
import "./index.scss"

interface LinkProps {
   to: string
   external?: boolean
   className?: string
   children: ReactNode
   variant?: LinkVariant
   underline?: boolean
   onClick?: () => void
}

export enum LinkVariant {
   PRIMARY = "--primary",
   SECONDARY = "--secondary",
}

const Link: FC<LinkProps> = ({
   to,
   external = false,
   className,
   children,
   variant = LinkVariant.PRIMARY,
   underline = false,
   onClick,
}) => {
   const getClassName = useCallback(() => {
      return classNames("link", className, `link${variant}`, {
         "link--underline": underline,
      })
   }, [className, underline, variant])

   if (external) {
      return (
         <a
            href={to}
            className={getClassName()}
            target="_blank"
            rel="noopener noreferrer"
         >
            {children}
         </a>
      )
   }

   return (
      <RouterLink
         to={to}
         className={getClassName()}
         onClick={onClick}
      >
         {children}
      </RouterLink>
   )
}

export default Link
